// AppBuilder API Response Types
export interface AppBuilderProjectResponse {
  project_id: string;
  project_name: string;
  status: AppBuilderProjectStatus;
  progress: number;
  message: string;
  github_url?: string;
  live_url?: string;
  qr_code?: string;
  created_at: string;
  completed_at?: string;
  error_message?: string;
}

export interface AppBuilderProjectRequest {
  user_name: string;
  project_idea: string;
  project_name?: string;
}

export interface AppBuilderProgressUpdate {
  project_id: string;
  status: AppBuilderProjectStatus;
  progress: number;
  message: string;
  timestamp: string;
}

export interface AppBuilderApiConfig {
  github_pages_url: string;
  max_project_name_length: number;
  allowed_file_types: string[];
  generation_timeout: number;
}

// Enums
export enum AppBuilderProjectStatus {
  STARTED = 'started',
  ANALYZING = 'analyzing',
  GENERATING = 'generating',
  PROCESSING = 'processing',
  COMMITTING = 'committing',
  DEPLOYING = 'deploying',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

// Component Props
export interface AppBuilderProjectFormProps {
  onSubmit: (request: AppBuilderProjectRequest) => void;
  isLoading: boolean;
}

export interface AppBuilderProgressBarProps {
  progress: number;
  status: AppBuilderProjectStatus;
  message: string;
  animated?: boolean;
}

export interface AppBuilderQRCodeDisplayProps {
  url: string;
  qrCode?: string;
  projectName: string;
}

export interface AppBuilderProjectCardProps {
  project: AppBuilderProjectResponse;
  onRefresh?: () => void;
}

// API Error Types
export interface AppBuilderApiError {
  error: string;
  message: string;
  details?: any[];
}

// WebSocket Types
export interface AppBuilderWebSocketMessage {
  type: 'progress' | 'complete' | 'error';
  data: AppBuilderProgressUpdate | AppBuilderProjectResponse | AppBuilderApiError;
}

// Form Validation
export interface AppBuilderFormErrors {
  user_name?: string;
  project_idea?: string;
  project_name?: string;
}

// UI State
export interface AppBuilderUIState {
  isLoading: boolean;
  error: string | null;
  success: string | null;
}

// Configuration
export interface AppBuilderAppConfig {
  apiBaseUrl: string;
  wsBaseUrl: string;
  maxRetries: number;
  retryDelay: number;
}
